export default __webpack_public_path__ + "static/media/FiraSans-BookItalic.9171847c.otf";